import { PlanOptionDto } from "@/features/planSelection/dtos/PlanOptionDto";

export const planDto = ({
    id,
    whmcsProductId,
    groupKey,
    displayName,
    features,
    price,
    billingLabel,
    link,
    rationale,
    isPopular,
}: PlanOptionDto): PlanOptionDto => ({
    id,
    whmcsProductId,
    groupKey,
    displayName,
    features,
    price,
    billingLabel,
    link,
    rationale,
    isPopular,
});